
// function checkLines(){
//   $(".detail").each(function(){
//     let p=$(this).find("p").first(),btn=$(this).find(".read-more");
//     if(!p.length||!btn.length)return;
//     let lh=parseFloat(p.css("line-height")),lines=p[0].scrollHeight/lh;
//     btn.toggle(lines>2);
//   });
// }
// $(document).ready(function(){
//   checkLines();$(window).on("resize",checkLines);
//   $(".read-more").on("click",function(e){
//     e.preventDefault();
//     let p=$(this).siblings("p"),ar=window.location.pathname.includes('/ar');
//     p.toggleClass("expanded");
//     $(this).text(p.hasClass("expanded")?(ar?'قراءة أقل':'Read less'):(ar?'قراءة المزيد':'Read more'))
//            .css({position:p.hasClass("expanded")?"unset":"",marginTop:p.hasClass("expanded")?"10px":"0"});
//   });
// });
// $(document).ready(function() {
//   $(".detail").each(function() {
//     const arabicPattern = /[\u0600-\u06FF]/;
//     if (!$(this).find("p").length && arabicPattern.test($(this).text())) {
//       $(this).wrapInner("<p></p>");
//     }
//   });

//   function checkLines(){
//     $(".detail").each(function(){
//       let p = $(this).find("p").first(), btn = $(this).find(".read-more");
//       if(!p.length || !btn.length) return;
//       let lh = parseFloat(p.css("line-height")),
//           lines = p[0].scrollHeight / lh;
//       btn.toggle(lines > 2);
//     });
//   }

//   checkLines();
//   $(window).on("resize", checkLines);

//   $(".read-more").on("click", function(e) {
//     e.preventDefault();
//     // p ab ya to sibling ho ya parent ke andar ho, safest ye:
//     let p = $(this).closest(".detail").find("p").first(),
//         ar = window.location.pathname.includes('/ar');
//     p.toggleClass("expanded");
//     $(this).text(p.hasClass("expanded") ? (ar ? 'قراءة أقل' : 'Read less') : (ar ? 'قراءة المزيد' : 'Read more'))
//            .css({position: p.hasClass("expanded") ? "unset" : "", marginTop: p.hasClass("expanded") ? "10px" : "0"});
//   });

//   checkLines();
// });
$(document).ready(function() {

  $(".detail").each(function() {
    const arabic = /[\u0600-\u06FF]/;
    if (!$(this).find("p").length && arabic.test($(this).text())) {
      $(this).wrapInner("<p></p>");
    }
  });

  function checkLines(){
    $(".detail").each(function(){
      let p = $(this).find("p").first(),
          btn = $(this).find(".read-more");
      if(!p.length || !btn.length) return;

      let lh = parseFloat(p.css("line-height")),
          lines = Math.round(p[0].scrollHeight / lh);

      btn.toggle(lines > 2);
    });
  }

  checkLines();
  $(window).on("resize", checkLines);

  $(".read-more").on("click", function(e){
    e.preventDefault();
  
    let box = $(this).closest(".detail"),
        p = box.find("p").first(),
        ar = location.pathname.includes('/ar');
  
    let expanded = p.hasClass("expanded");
  
    p.toggleClass("expanded");
  
    $(this).text(
      expanded ?
      (ar ? "قراءة المزيد" : "Read more") :
      (ar ? "قراءة أقل" : "Read less")
    );
  
    if(expanded){
      $(this).css({position:"", marginTop:""});
    } else {
      $(this).css({position:"unset", marginTop:"10px"});
    }
  });
  

});

window.addEventListener("load", () => {
  setTimeout(() => {
    document.body.classList.add("loaded");
  }, 0);
});

document.querySelectorAll('input[type=number]').forEach(inp=>{
  inp.addEventListener('keydown',e=>{
    if(e.key==='e'||e.key==='E'||e.key==='+'||e.key==='-')e.preventDefault()
  })
})
